// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ATzD","select":"Header_select__2a5ZR","clinic":"Header_clinic__1GARQ"};